import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            主题索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按题材快速找到你想看的漫画，八大分类覆盖全类型漫画作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 cursor-pointer transition-all duration-300 hover:scale-[1.03]"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100/70 flex items-center justify-center mb-4 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`} />
              </div>
              <h3 className="font-semibold text-base text-foreground-950">{item.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center gap-1.5">
                <span className="text-xs text-primary-600 font-medium">{item.count}</span>
                <i className="ri-arrow-right-line text-xs text-primary-400" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}